module.exports = __webpack_public_path__ + "img/1575313124.dd93ea07.jpg";